import { useEffect, useState } from 'react';
import {
  FALLBACK_SOLO_PRICES,
  parseSoloPrices,
  type SoloPrices,
} from './soloPrice';

const TIMEOUT_MS = 5000;

// Starts at the built-in fallback and swaps to the API set as one unit when a
// valid answer arrives. Any failure keeps the fallback.
export const useSoloPrices = (): SoloPrices => {
  const [prices, setPrices] = useState<SoloPrices>(FALLBACK_SOLO_PRICES);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    // react-snap prerender keeps the fallback so hydration matches.
    if (!apiUrl || navigator.userAgent === 'ReactSnap') return undefined;

    let cancelled = false;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

    (async () => {
      try {
        const res = await fetch(`${apiUrl}/payments/plans/`, {
          signal: controller.signal,
        });
        if (!res.ok) return;
        const parsed = parseSoloPrices(await res.json());
        if (parsed && !cancelled) setPrices(parsed);
      } catch {
        // timeout, network error or malformed body: keep the fallback
      } finally {
        clearTimeout(timeoutId);
      }
    })();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  return prices;
};
